import React from "react";
import { FormattedMessage } from "react-intl";
import { TextField, MenuItem } from "@material-ui/core";

const HistoryWithdrawalSingleSelect = ({ title, values, value, onChange }) => (
  <TextField
    select
    label={<FormattedMessage id={title} />}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    style={{ width: "100%", paddingTop: "5%" }}
  >
    {values.map(({ value: optionValue, label }) => (
      <MenuItem key={String(optionValue)} value={optionValue}>
        <FormattedMessage id={label} defaultMessage={label} />
      </MenuItem>
    ))}
  </TextField>
);

export default HistoryWithdrawalSingleSelect;
